import pimg1 from '../images/project/project-1/p1.jpg'
import pimg2 from '../images/project/project-1/p2.jpg'
import pimg3 from '../images/project/project-1/p3.jpg'
import pimg4 from '../images/project/project-1/p4.jpg'

import Sing1 from '../images/project-single/p1.jpg'
import Sing2 from '../images/project-single/p2.jpg'
import Sing3 from '../images/project-single/p3.jpg'
import Sing4 from '../images/project-single/p4.jpg'

// ================= SOLVE IMAGES =================

// Hallmark Oakshire
import oakSolve1 from '../images/project-single/solve/p1-1.jpg'
import oakSolve2 from '../images/project-single/solve/p1-2.jpg'
import oakSolve3 from '../images/project-single/solve/p1-3.jpg'

// Rajasekhar
import rajaSolve1 from '../images/project-single/solve/p2-1.jpg'
import rajaSolve2 from '../images/project-single/solve/p2-2.jpg'
import rajaSolve3 from '../images/project-single/solve/p2-3.jpg'

// Krishna Farm House
import krishSolve1 from '../images/project-single/solve/p3-1.jpg'
import krishSolve2 from '../images/project-single/solve/p3-2.jpg'
import krishSolve3 from '../images/project-single/solve/p3-3.jpg'

// Clubhouse
import clubSolve1 from '../images/project-single/solve/p4-1.jpg'
import clubSolve2 from '../images/project-single/solve/p4-2.jpg'
import clubSolve3 from '../images/project-single/solve/p4-3.jpg'

import VideoBg1 from '../images/p1.jpg'
import VideoBg2 from '../images/p2.jpg'
import VideoBg3 from '../images/p3.jpg'
import VideoBg4 from '../images/p4.jpg'

const Projects = [
    {
    id: '1',
    title: 'Gardenia Villa',
    subtitle: 'G+2 Premium Residential Villa',
    slug: 'gardenia-villa-chandanagar',
    pimg: pimg1,
    sing: Sing1,
    location: 'Chanda Nagar',
    architect: 'Ar. Y. Veera Reddy',
    client: 'Mrs. Niveditha',
    projectType: 'Premium Residential Villa',
    projectSize: '6,708 sq. ft.',

    intro: [
        "Gardenia Villa is a G+2 premium residential villa located in the residential neighborhood of Chanda Nagar. The project was conceived as a contemporary family residence that emphasizes spatial efficiency, architectural clarity, and refined interior execution.",
        "Designed to accommodate modern living requirements, the villa integrates well-defined functional zones across multiple levels while maintaining a seamless spatial flow. The planning prioritizes comfort, usability, and long-term adaptability for the residents.",
        "The architectural planning and interior execution were carried out by Ar. Y. Veera Reddy, ensuring that the design intent was consistently translated into built form with attention to proportion, detailing, and execution quality."
    ],

    description: [
        "With a total built-up area of 6,708 square feet, Gardenia Villa is structured across ground plus three floors, allowing for generous living spaces while maintaining efficient vertical circulation. Each floor has been carefully planned to support both private and shared activities without spatial conflict.",
        "The architectural layout emphasizes clarity in movement, ensuring that transitions between spaces are intuitive and functional. Staircases, passages, and internal connections were designed to support smooth circulation across all levels of the residence.",
        "Interior execution focuses on clean spatial planning, balanced proportions, and thoughtful material application. The design approach avoids excessive ornamentation, instead emphasizing timeless aesthetics, functionality, and durability.",
        "Natural light and ventilation were key considerations throughout the planning process. Openings were strategically positioned to allow daylight penetration and airflow across multiple floors, contributing to comfortable interior environments.",
        "The project reflects strong coordination between architectural drawings and on-site execution, resulting in a residence that aligns closely with the original design vision while meeting practical living requirements."
    ],

    challenges: [
        "Planning a G+3 residential structure while ensuring comfortable movement and circulation across floors",
        "Maintaining spatial consistency and usability across multiple levels",
        "Coordinating architectural planning with interior execution",
        "Ensuring accurate translation of design intent during on-site execution"
    ],

    solutions: [
        "Implemented clear vertical zoning to define functional areas on each floor",
        "Maintained close coordination between architectural planning and interior execution teams",
        "Optimized layouts to enhance spatial efficiency and ease of movement",
        "Focused on execution detailing to ensure consistency between drawings and final output"
    ],

    features: [
        "G+3 premium residential villa planning",
        "Spacious living and family areas",
        "Clear separation of private and common zones",
        "Architect-led interior execution",
        "Efficient vertical circulation planning",
        "Balanced natural lighting and ventilation",
        "Clean architectural language with refined detailing",
        "Client-focused residential planning approach"
    ],

    solveImages: [oakSolve1, oakSolve2, oakSolve3],
    videoBg: VideoBg1
}


    ,
    {
    id: '2',
    title: 'Independent House – Bansuwada',
    subtitle: 'Premium G+3 Residential Villa',
    slug: 'rajasekhar-bansuwada',
    pimg: pimg2,
    sing: Sing2,
    location: 'Bansuwada',
    architect: 'Ar. Y. Veera Reddy',
    client: 'Mr. Rajasekhar',
    projectType: 'Premium Residential Villa',
    projectSize: '7,200 sq. ft.',

    intro: [
        "This project is a premium G+3 independent residential villa located in Bansuwada, developed from open land into a fully realized family residence. Designed to meet modern residential requirements, the villa reflects a balance between functional planning, architectural clarity, and refined interior execution.",
        "Owned by Mr. Rajasekhar, the residence was conceived as a long-term family home with emphasis on spacious interiors, vertical zoning, and well-defined living areas across multiple floors. The planning accommodates daily living needs while allowing flexibility for future use.",
        "The architectural design and complete interior execution were carried out by Ar. Y. Veera Reddy, ensuring a seamless transition from conceptual planning to on-site execution, with close attention to detailing and spatial proportions."
    ],

    description: [
        "With a built-up area of 7,200 square feet, the villa is structured across ground plus three floors, allowing generous living spaces without compromising circulation efficiency. Each floor is carefully planned to serve specific functions while maintaining overall spatial continuity.",
        "The architectural layout emphasizes clarity in movement, with well-planned staircases and circulation zones that connect all levels smoothly. Functional zoning ensures that private, semi-private, and common areas are clearly distinguished.",
        "Interior design execution focuses on clean layouts, practical furniture planning, and material selections that enhance both durability and aesthetics. The interiors are designed to complement the architectural form rather than overpower it, resulting in a cohesive residential environment.",
        "Natural light and ventilation were key considerations throughout the design process. Openings and balconies were strategically placed to ensure adequate daylight penetration and airflow across all floors, enhancing indoor comfort.",
        "The project demonstrates strong coordination between architectural drawings and execution, resulting in a residence that accurately reflects the original design intent from open land to completed structure."
    ],

    challenges: [
        "Planning a premium G+3 villa on open land with efficient vertical zoning",
        "Ensuring smooth circulation and spatial comfort across multiple floors",
        "Coordinating architectural design with detailed interior execution",
        "Maintaining consistency between planning intent and on-site implementation"
    ],

    solutions: [
        "Developed clear vertical zoning to assign distinct functions to each floor",
        "Optimized circulation layouts to ensure ease of movement throughout the villa",
        "Maintained close coordination between architectural planning and interior execution",
        "Focused on execution accuracy to translate drawings into built form effectively"
    ],

    features: [
        "Premium G+3 independent villa planning",
        "Spacious living and family areas across multiple floors",
        "Clear separation of private and common zones",
        "Architect-led interior design execution",
        "Efficient vertical circulation planning",
        "Balanced natural lighting and ventilation",
        "Clean architectural language with refined detailing",
        "Designed as a complete end-to-end residential project"
    ],

    solveImages: [rajaSolve1, rajaSolve2, rajaSolve3],
    videoBg: VideoBg2
}

    ,
    {
    id: '3',
    title: 'Farm House – Moinabad',
    subtitle: 'Residential Farm House',
    slug: 'krishna-moinabad-farm-house',
    pimg: pimg3,
    sing: Sing3,
    location: 'Moinabad',
    architect: 'Ar. Y. Veera Reddy',
    client: 'Mr. Krishna',
    projectType: 'Residential Farm House',
    projectSize: '5,345 sq. ft.',

    intro: [
        "This project is a residential farm house developed for Mr. Krishna in Moinabad, designed as a peaceful retreat away from the urban environment. The farmhouse was conceived to offer a calm, nature-oriented living experience while maintaining functional and comfortable interior spaces.",
        "The design approach focuses on openness, spatial flow, and a strong connection between indoor and outdoor environments. The planning emphasizes relaxed living, making the farmhouse suitable for both everyday use and family gatherings.",
        "The architectural design and complete interior execution were carried out by Ar. Y. Veera Reddy, ensuring a unified design language from planning to final execution, with careful attention to spatial proportions and detailing."
    ],

    description: [
        "With a built-up area of 5,345 square feet, the farmhouse is planned to provide spacious interiors while maintaining a sense of simplicity and openness. The layout allows for comfortable movement between spaces and encourages natural interaction with the surrounding landscape.",
        "The architectural planning prioritizes natural light and ventilation, using well-positioned openings and open transitional spaces to create comfortable interior environments. The design avoids unnecessary complexity, focusing instead on clarity, functionality, and long-term usability.",
        "Interior design execution complements the architectural layout through clean spatial arrangements and material selections that enhance durability and comfort. The interiors are designed to support relaxed living while maintaining visual consistency throughout the residence.",
        "The project demonstrates close coordination between architectural planning and on-site execution, resulting in a farmhouse that accurately reflects the original design intent and fulfills the client’s expectations."
    ],

    challenges: [
        "Designing a farmhouse that balances openness with functional interior planning",
        "Ensuring comfortable natural lighting and ventilation across all living spaces",
        "Coordinating architectural planning with interior execution",
        "Maintaining design consistency during on-site execution"
    ],

    solutions: [
        "Developed an open and flexible layout that encourages indoor-outdoor interaction",
        "Strategically placed openings to enhance daylight and airflow",
        "Maintained close collaboration between architectural design and execution teams",
        "Focused on execution accuracy to preserve the intended design language"
    ],

    features: [
        "Residential farmhouse planning",
        "Spacious living and common areas",
        "Strong indoor-outdoor spatial connection",
        "Architect-led interior design execution",
        "Functional circulation planning",
        "Balanced natural lighting and ventilation",
        "Simple and refined architectural language",
        "Designed as a calm retreat from urban living"
    ],

    solveImages: [krishSolve1, krishSolve2, krishSolve3],
    videoBg: VideoBg3
}

    ,
   {
    id: '4',
    title: 'Hallmark Oakshire Clubhouse',
    subtitle: 'G+2 Community Clubhouse',
    slug: 'hallmark-oakshire-clubhouse',
    pimg: pimg4,
    sing: Sing4,
    location: 'Tukkaguda',
    architect: 'Ar. Y. Veera Reddy',
    client: 'Hallmark Builders',
    projectType: 'Community Clubhouse',
    projectSize: '7,519 sq. ft.',

    intro: [
        "The Hallmark Oakshire Clubhouse is a G+2 community facility developed as part of the Hallmark Oakshire residential project at Tukkaguda. Conceived as a central gathering space, the clubhouse was designed to support social interaction, recreation, and community engagement for residents.",
        "Developed from open land, the project was architecturally planned to function as a shared amenity that complements the surrounding residential development while establishing its own identity as a community focal point.",
        "The architectural design and complete interior execution were carried out by Ar. Y. Veera Reddy, ensuring a cohesive transition from conceptual planning to built form, with emphasis on functionality, spatial clarity, and execution quality."
    ],

    description: [
        "With a total built-up area of 7,519 square feet, the clubhouse is structured across ground plus two floors, allowing the accommodation of multiple activities within a compact yet efficient footprint. The vertical planning ensures clear zoning of spaces while maintaining smooth circulation across levels.",
        "The architectural layout focuses on flexibility, enabling the clubhouse to host a variety of community activities. Spaces are designed to be adaptable, supporting gatherings, meetings, and recreational use without rigid spatial constraints.",
        "Interior design execution emphasizes durable materials, clean finishes, and practical layouts suitable for frequent public use. The interiors are designed to be welcoming and functional while maintaining visual consistency with the overall architectural language.",
        "Natural light and ventilation were integral to the planning process, with openings positioned to enhance indoor comfort and reduce dependency on artificial lighting. The project reflects a balanced approach between architectural expression and everyday usability.",
        "Strong coordination between architectural planning and on-site execution ensured accurate translation of design intent, resulting in a clubhouse that effectively serves its role as a community-oriented space."
    ],

    challenges: [
        "Planning a G+2 clubhouse that accommodates multiple community functions",
        "Ensuring efficient circulation across floors for shared public use",
        "Balancing architectural identity with integration into the residential development",
        "Maintaining execution quality for a high-usage community facility"
    ],

    solutions: [
        "Developed clear vertical zoning to organize activities across floors",
        "Designed circulation paths that support smooth movement between spaces",
        "Maintained architectural continuity while giving the clubhouse a distinct presence",
        "Focused on precise execution to ensure durability and long-term usability"
    ],

    features: [
        "G+2 community clubhouse planning",
        "Multi-purpose spaces for gatherings and activities",
        "Efficient vertical circulation layout",
        "Architect-led interior design execution",
        "Durable materials suitable for public use",
        "Balanced natural lighting and ventilation",
        "Clear zoning for functional flexibility",
        "Designed as a central amenity for the residential community"
    ],

    solveImages: [clubSolve1, clubSolve2, clubSolve3],
    videoBg: VideoBg4
}

]

export default Projects